module.exports = __webpack_public_path__ + "static/media/portfolio_site_sagely_app_1_Logo.11febd32.png";